import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { useWaybillContext } from "../../../context/waybill_context";
import { useUserContext } from "../../../context/user_context";
import Api from "../../../api/axios";
import { Button, Form, Input, Label, Textarea } from "../../../styles";
import { namePlaceholder, phonePlaceholder } from "../../../utils/data";
import { useSalesContext } from "../../../context/sales_context";

const AddWaybill = (props) => {

  const { invid } = props;

  const [issending, setissending] = useState(false);

  // Form Fields
  const [formField, setformField] = useState({
    invid: invid,
    vehicleNumber: "",
    driverName: "",
    driverNumber: "",
    receiverName: "",
    receiverNumber: "",
    rAddress: "",
  });

  const {
    showAddWaybill, CloseAddWaybill,
    getWaybillData
  } = useWaybillContext();

  const { usertoken, btoken, stoken } = useUserContext();

  const {
    getSalesItem
  } = useSalesContext();


  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }
  // Form Fields

  function clear() {
    setformField({
      invid: invid,
      vehicleNumber: "",
      driverName: "",
      driverNumber: "",
      receiverName: "",
      receiverNumber: "",
      rAddress: "",
    });
  }

  //  Add Waybill Function
  //  Add Waybill Function
  function submitFn(e) {
    e.preventDefault();
    if (formField.vehicleNumber && formField.driverName && formField.driverNumber && formField.receiverName && formField.receiverNumber && formField.rAddress) {
      setissending(true);
      const data = {
        driverName: formField.driverName,
        driverNumber: formField.driverNumber,
        vehicleNumber: formField.vehicleNumber,
        rName: formField.receiverName,
        rNumber: formField.receiverNumber,
        rAddress: formField.rAddress,
        invid: formField.invid,
        usertoken,
        stoken,
        btoken,
      };
      Api.post(`/wayBill.add`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            clear();
            CloseAddWaybill();
            getSalesItem(invid);
            getWaybillData();
          }
        })
        .catch((error) => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.error('Empty Fields!');
    }
  }
  //  Add Waybill Function
  //  Add Waybill Function

  return (
    <>
      <Modal
        show={showAddWaybill}
        onHide={CloseAddWaybill}
        backdrop="static"
        keyboard={true}
        centered
        size="lg"
      >
        <Modal.Body >
          <Modal.Header closeButton >
            <h6 className="fw-bold pry-text">
              Create a new Waybill
            </h6>
          </Modal.Header>

          <div className="container">
            <Form onSubmit={(e) => submitFn(e)}>

              <Label> Driver's Name: <span>*</span> </Label>
              <Input
                type="text"
                name="driverName"
                placeholder={namePlaceholder}
                onChange={handleChange}
                required
                value={formField.driverName}
              />

              <Label> Driver's Number: <span>*</span> </Label>
              <Input
                type="number"
                name="driverNumber"
                placeholder={phonePlaceholder}
                onChange={handleChange}
                required
                value={formField.driverNumber}
              />

              <Label> Vehicle's Number: <span>*</span> </Label>
              <Input
                type="text"
                name="vehicleNumber"
                placeholder="e.g. AQW1233AQ"
                onChange={handleChange}
                required
                value={formField.vehicleNumber}
              />

              <Label> Receiver's Name: <span>*</span> </Label>
              <Input
                type="text"
                name="receiverName"
                placeholder={namePlaceholder}
                onChange={handleChange}
                required
                value={formField.receiverName}
              />


              <Label> Receiver's Number: <span>*</span> </Label>
              <Input
                type="number"
                name="receiverNumber"
                placeholder={phonePlaceholder}
                onChange={handleChange}
                required
                value={formField.receiverNumber}
              />

              <Label> Receiver's Address: <span>*</span> </Label>
              <Textarea
                type="text"
                name="rAddress"
                placeholder={"e.g. 123, ABC Street, XYZ City"}
                rows="3"
                onChange={handleChange}
                required
                value={formField.rAddress}
              ></Textarea>

              <div className="col-md-10 mx-auto text-center mb-4">
                <Button
                  pry
                  type="submit"
                  disabled={issending}
                  className="btn m-0 w-100"  >
                  {issending ? 'loading...' : "Submit"}
                </Button>
              </div>

            </Form>
          </div>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default AddWaybill;
